<template>
  <!-- 新增/编辑弹窗 -->
  <el-dialog
    :title="isAdd ? '新增' : '编辑'"
    :top="dialogTop"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    @close="closeDialog"
  >
    <el-form :model="dialogForm" :rules="rules" ref="form" v-load="formLoading">
      <!-- 邮箱 -->
      <el-form-item label="邮箱" prop="email">
        <el-input
          v-model="dialogForm.email"
          placeholder="请输入邮箱"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="mini" @click="closeDialog">取 消</el-button>
      <el-button
        size="mini"
        type="primary"
        :loading="btnLoading"
        :disabled="btnLoading"
        @click="submit"
      >
        {{ isAdd ? "确 定" : "保 存" }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  model: {
    prop: "show"
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    // 新增还是编辑
    isAdd: {
      type: Boolean,
      default: true
    },
    // 新增还是编辑
    dialogTop: {
      type: String,
      default: "10vh"
    }
  },
  data() {
    return {
      dialogVisible: this.show,
      formLoading: false,
      btnLoading: false,
      rules: {
        email: [{ required: true, message: "请输入邮箱", trigger: "blur" }]
      },
      dialogForm: {
        email: ""
      }
    };
  },
  watch: {
    show(val) {
      this.dialogVisible = val;
    }
  },
  methods: {
    // 点击确定
    submit() {},
    // 关闭弹窗
    closeDialog() {
      this.$emit("input", false);
    }
  }
};
</script>

<style lang="less" scoped></style>



// WEBPACK FOOTER //
// src/pages/index/riskViews/formalUser/components/editDialog.vue